import createPersistedState from "vuex-persistedstate";
import {createStore} from "vuex";

const store = createStore({
	state() {
		return {
			newsCurrentPage: 1, // 新闻的当前页码
			platformTab: 0, // 平台 Tab 的索引
			topicTab: 0, // 专题 Tab 的索引
		};
	},
	mutations: {
		setNewsCurrentPage(state, page) {
			state.newsCurrentPage = page;
		},
		setPlatformTab(state, tab) {
			state.platformTab = tab;
		},
		setTopicTab(state, tab) {
			state.topicTab = tab;
		},
	},
	getters: {
		getNewsCurrentPage: (state) => state.newsCurrentPage,
		getPlatformTab: (state) => state.platformTab,
		getTopicTab: (state) => state.topicTab,
	},
	plugins: [
		// 为 newsCurrentPage 定义一个独立的存储
		createPersistedState({
			key: "vuex-news-page", // 自定义存储键名
			paths: ["newsCurrentPage"], // 仅存储 newsCurrentPage
			storage: window.localStorage, // 存储到 localStorage
		}),
		createPersistedState({
			key: "vuex-platform-tab",
			paths: ["platformTab"],
			storage: window.localStorage,
		}),
		createPersistedState({
			key: "vuex-topic-tab",
			paths: ["topicTab"],
			storage: window.localStorage,
		}),
	],
});

export default store;
